import type { HomeSectionLivancePayCardGroupFragmentFragment } from "@repo/graphql-types/graphql";

interface HomeSectionLivancePayMapperOutput {
  pagos: number;
  total: number;
  totalPaidAmount: number;
  totalPendingAmount: number;
}

export const mapPaymentsToHomeData = (
  data: HomeSectionLivancePayCardGroupFragmentFragment
): HomeSectionLivancePayMapperOutput => {
  const pagosOnline = data.pagosOnline.aggregate?.count ?? 0;
  const pendentesOnline = data.pendentesOnline.aggregate?.count ?? 0;
  const pagosTotem = data.pagosTotem.aggregate?.count ?? 0;
  const pendentesTotem = data.pendentesTotem.aggregate?.count ?? 0;

  const online = data.ExpensumGetPaymentsChartsInfo.periods[0]?.onlinePayments;
  const totem = data.ExpensumGetPaymentsChartsInfo.periods[0]?.totemPayments;

  const totalPaidAmount =
    online.paid.totalAmount + totem.paid.totalAmount;
  const totalPendingAmount =
    online.created.totalAmount -
      online.paid.totalAmount +
    totem.created.totalAmount -
      totem.paid.totalAmount;

  return {
    pagos: pagosOnline + pagosTotem,
    total: pagosOnline + pagosTotem + pendentesOnline + pendentesTotem,
    totalPaidAmount,
    totalPendingAmount,
  };
};
